export const endpoints = {
  auth: {
    login: '/api/auth/login',
    logout: '/api/auth/logout',
    me: '/api/me',
  },
  chat: {
    visitors: (skip: number, limit: number, flagged?: boolean) => {
      const params = new URLSearchParams({
        skip: String(skip),
        limit: String(limit),
      });
      if (flagged) params.append('flagged', 'true');
      return `/api/v1/chat/visitors?${params.toString()}`;
    },
    messages: (visitorId: string, skip: number, limit: number) =>
      `/api/v1/chat/messages/${visitorId}?skip=${skip}&limit=${limit}&include_system_messages=true`,
    markRead: (visitorId: string) =>
      `/api/v1/chat/visitors/${visitorId}/mark-read`,
    flag: (visitorId: string) => `/api/v1/chat/visitors/${visitorId}/flag`,
    unflag: (visitorId: string) => `/api/v1/chat/visitors/${visitorId}/unflag`,
    exportPDF: (visitorId: string) =>
      `/api/v1/chat/visitors/${visitorId}/export-pdf`,
    exportInfo: '/api/v1/chat/exports/latest/info',
    exportDownload: '/api/v1/chat/exports/latest',
  },
  analytics: {
    dashboard: (startDate?: string, endDate?: string) => {
      const params = new URLSearchParams();
      if (startDate) params.append('start_date', startDate);
      if (endDate) params.append('end_date', endDate);
      const queryString = params.toString();
      return `/api/v1/analytics/dashboard${queryString ? `?${queryString}` : ''}`;
    },
  },
  chatbot: '/api/v1/chatbot',
  emailCapture: {
    records: (skip: number, limit: number) =>
      `/api/v1/email-capture/records?offset=${skip}&limit=${limit}`,
    record: (id: number) => `/api/v1/email-capture/records/${id}`,
  },
  documents: {
    list: (skip: number, limit: number) =>
      `/api/v1/documents?skip=${skip}&limit=${limit}`,
    upload: '/api/v1/documents',
    download: (id: number) => `/api/v1/documents/${id}/download`,
    delete: (id: number) => `/api/v1/documents/${id}`,
    updateScope: (id: number) => `/api/v1/documents/${id}`,
  },
  users: {
    list: '/api/v1/users',
    create: '/api/v1/users',
    update: (userId: number) => `/api/v1/users/${userId}`,
    delete: (userId: number) => `/api/v1/users/${userId}`,
    deactivate: (userId: number) => `/api/v1/users/${userId}/deactivate`,
    activate: (userId: number) => `/api/v1/users/${userId}/activate`,
  },
};
